import { Icon } from "@msuite/ui/icons";
import { Popover } from "@msuite/ui/popover";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import { ProjectPopover } from "@/components/popovers/project-popover";
import { client } from "@/hono";

/** Props Interface */
interface ProjectCardMentionProps {
	projectId: string;
}

export function ProjectCardMention({ projectId }: ProjectCardMentionProps) {
	/** Hooks */
	const { data: project } = useQuery({
		queryKey: ["project", projectId],
		queryFn: async () => {
			const response = await client.projects[":projectId"].$get({
				param: { projectId },
			});
			const json = await responseHandler(response);
			return json.project;
		},
	});

	/** Guard */
	if (!projectId) return <p>{guardString(null)}</p>;
	if (!project) return <p>{guardString(null)}</p>;

	/** Render */
	return (
		<Popover
			trigger="click"
			render={() => <ProjectPopover projectId={projectId} />}
			variant="plain"
		>
			<div className="h-stack inline-flex">
				<Icon
					name="FolderOpen"
					color="var(--color-accent-500)"
				/>
				<p>{project?.name}</p>
			</div>
		</Popover>
	);
}
